module.exports = __webpack_public_path__ + "img/ai_bubble_button-close.2eea174.png";